import React, { useState, useEffect } from 'react';
import { Box, IconButton, Menu, MenuItem, Typography, Badge, Button } from '@mui/material';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import useNotificationHandler from '../../NotificationHandler'; // Ensure this is the updated handler from earlier
import { useNavigate } from 'react-router-dom'; // For navigation
import { BemsGraph, FemsGraph } from "../../utility/apiURLS";
import { getAuthToken, getFacilityId } from "../../utility/tokenUtility";
import axios from "axios";
import { formatDistanceToNow } from 'date-fns'; // Importing date-fns for relative time formatting
import { useDispatch, useSelector } from "react-redux";
import {
  updateOutsourceDetails,
  updateWorkOrderStatus,
} from '../../redux/actions/workOrderActionTypes';
// "../../redux/actions/workOrderActionTypes";
const NotificationsMenu = () => {
  const dispatch = useDispatch();
  const roleName = localStorage.getItem('roleName')?.trim();  // Fetch roleName once and trim spaces
  const facilityid = getFacilityId("");
  const navigate = useNavigate(); // Navigation hook
  const [anchorElNotification, setAnchorElNotification] = useState(null);
  const [notifications, setNotifications] = useState([]); // Store all notifications
  const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth()+1;
    const [sortModel, setSortModel] = useState([]);
    const [filterModel, setFilterModel] = useState([]);
    const token = getAuthToken("id_token");
    const departmentid = localStorage.getItem("roleName") === "DeptUser" ? 1:0;
    const userid = localStorage.getItem("UserId");
    const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
  // Add a notification to the list
  const addNotification = (notification) => {
    setNotifications((prev) => {
      const isDuplicate = prev.some(
        (notif) => notif.title === notification.title && notif.body === notification.body
      );

      if (!isDuplicate) {
        return [notification, ...prev];
      }

      return prev;
    });
  };

  // Initialize the Firebase notification listener
  // useEffect(() => { 
    // NotificationHandler.init(addNotification);
  // }, []);





  // ==need to uncomment for work notification==

    useNotificationHandler(addNotification);



  // Open the notifications menu
  const handleOpenNotificationMenu = (event) => {
    setAnchorElNotification(event.currentTarget);
  };

  // Close the notifications menu
  const handleCloseNotificationMenu = () => {
    setAnchorElNotification(null);
    // setNotifications([]);
  };

  // Navigate to the dashboard
  const handleShowMore = () => {
    // setAnchorElNotification(null);
    navigate('/departmentworkrequest'); // Adjust the path as needed
    setAnchorElNotification(null); // Close the menu
  };

    // Handle notification click
    const handleNotificationClick = async(notification) => {
      try{
        let response;
        if(roleName === 'Helpdesk' || roleName === 'FMSExec' ){
        if (notification?.data?.WorkGroupType === "FEMS") {
            response = await axios.get(
              `${FemsGraph}/api/GraphfemDepartmentrequest/GetWorkRequestExport/${facilityid}/${currentYear}/${currentMonth}?filterOptions=${JSON.stringify(
                filterModel
              )}&sortOptions=${JSON.stringify(sortModel)}`,
              config
            );
    
          } else if (notification?.data?.WorkGroupType === "BEMS") {
            response = await axios.get(
              `${BemsGraph}/api/GraphbemDepartmentrequest/GetWorkRequestExport/${facilityid}/${currentYear}/${currentMonth}?filterOptions=${JSON.stringify(
                filterModel
              )}&sortOptions=${JSON.stringify(sortModel)}`,
              config
            );
        }

        response=response?.data?.filter((item)=>item.id===notification?.data?.WorkOrderId);
        if(response?.length>0){      
        navigate("departmentworkrequest/register", {
              state: {
                ...response[0],
                isEditMode: true,
                assetno: { label: response[0].assetno, value: response[0].assetId },
                categoryId: { label: response[0].categoryName, value: response[0].categoryId },
                typeId: { label: response[0].type, value: response[0].typeId },
              },
            });
        }
      }else if(roleName === 'FMSExec' || roleName === 'HospitalFM'){
        const [year, month] = notification?.data?.Date?.split("-").map(Number)    
        if (notification?.data?.WorkGroupType === "FEMS") {
          response = await axios.get(
            `${FemsGraph}/api/Graphfemworkorder/GetCombinedWorkOrderSchedules/${facilityid}/${year}/${month}/${departmentid}/${userid}/${token}`,
            config
        )
    
        } else if (notification?.data?.WorkGroupType === "BEMS") {
          response = await axios.get(
            `${BemsGraph}/api/Graphbemworkorder/GetCombinedWorkOrderSchedules//${facilityid}/${year}/${month}/${departmentid}/${userid}/${token}`,
            config
        )
      }
      response=response?.data?.items?.filter((item)=>item.id===notification?.data?.WorkOrderId);
      if(response?.length>0){      
        const serviceType = response?.service === "FEMS" ? "fem" : "bem";
        const categoryType = response?.maintenanceType === "Scheduled" ? "Scheduled" : "Unscheduled";
        // dispatch({ type: 'CLEAR_BASIC_DETAILS_WORK_ORDER_SUMMARY', payload: {} });
        // dispatch(updateOutsourceDetails("SET_VENDORFIELD", false));
        // dispatch({
        //     type: "SERVICE&CATEGORY_TYPE", payload: {
        //         assetType: serviceType,
        //         category: categoryType
        //     }
        // });
        // dispatch(updateWorkOrderStatus("STATUS_CHANGES", { status: response?.status, percentage: 0 }))
        const title = `Edit ${categoryType} Work Order`;
             navigate("workorder/register", { state: { ...response, service: serviceType, readOnly: false, editmode: true, category: categoryType, viewmode: false, title } });
    
        }
    
      }
      }catch(e){
          console.error(e)
        }
        finally{
          setNotifications(notifications?.filter((item)=>item.body!=notification?.body))
        }
         setAnchorElNotification(null); // Optionally close the menu
      };
    

  return (
    <Box>
      <Box>
        {/* Bell Icon with Badge */}
        <IconButton onClick={handleOpenNotificationMenu} sx={{ p: 0 }}>
          <Badge badgeContent={notifications.length} color="error">
            <NotificationsNoneIcon sx={{ color: '#FFF' }} />
          </Badge>
        </IconButton>

        {/* Notifications Menu */}
        <Menu
  sx={{ mt: '25px', zIndex: 1650 }}
  id="notification"
  keepMounted
  anchorEl={anchorElNotification}
  anchorOrigin={{
    vertical: 'top',
    horizontal: 'right',
  }}
  transformOrigin={{
    vertical: 'top',
    horizontal: 'right',
  }}
  open={Boolean(anchorElNotification)}
  onClose={handleCloseNotificationMenu}
>
  {/* Notifications Title */}
  {notifications.length > 0 && (
  <MenuItem  sx={{ justifyContent: 'center', backgroundColor: '#f8f8f8', py: 1 }}>
    <Typography sx={{ fontWeight: 'bold', fontSize: '16px'}}>
      Notifications
    </Typography>
  </MenuItem>
    )} 

  {/* Check if notifications exist */}
  {notifications.length === 0 && (
    <MenuItem disabled>
      <Typography textAlign="center">No Notifications</Typography>
    </MenuItem>
  )} 
  {/* : 
 (
    <> */}
      {/* Display the latest 10 notification titles */}
      {notifications.slice(0, 5).map((notif, index) => (
      <MenuItem
      key={index}
      onClick={() => handleNotificationClick(notif)}
      sx={{
        border: '0.2px solid #ddd', // Light gray border
        // margin: '5px 0', // Space between menu items
        padding: '10px', // Inner padding for better appearance
        backgroundColor: '#fff', // White background
        '&:hover': {
          backgroundColor: '#f0f0f0', // Light gray background on hover
        },
        // boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)', // Subtle shadow for depth
        display: 'flex',
        flexDirection: 'column', // Stack title and body vertically
        alignItems: 'flex-start', // Center align content
        justifyContent: 'flex-start', // Ensure content is centered vertically
        width: '350px', // Adjust the width here
      }}
    >
      <Box sx={{ textAlign: 'center', marginBottom: '5px' }}>
        <Typography sx={{ fontWeight: 'bold', fontSize: '14px', color: '#333' }}>
          {notif.title}
        </Typography>
      </Box>
      <Box sx={{ textAlign: 'center' }}>
        <Typography sx={{ fontSize: '14px', color: '#555', textAlign: 'left', textWrap: "auto" }}>
          {notif.body}
        </Typography>
      </Box>
      <Box sx={{ textAlign: 'left', marginTop: '5px' }}>
        <Typography sx={{ fontSize: '12px', color: '#999', fontStyle: 'italic' }}>
          {formatDistanceToNow(new Date(notif.timestamp), { addSuffix: true })}
        </Typography>
      </Box>
    </MenuItem>
    
      ))}

      {/* Show More Button */}
      {notifications.length > 5 && (
   <MenuItem
   onClick={handleShowMore}
   sx={{
    //  margin: '5px',
     padding: '10px',
     backgroundColor: '#f0f0f0',
    //  borderRadius: '4px',
     display: 'flex', // Flex container
     justifyContent: 'center', // Center horizontally
     alignItems: 'center', // Center vertically
     '&:hover': {
       backgroundColor: '#e0e0e0',
     },
   }}
 >
   <Typography
     sx={{
       fontWeight: 'bold',
       fontSize: '14px',
       color: '#007bff',
       textAlign: 'center', // Ensures the text itself is centered
     }}
   >
     Show More
   </Typography>
 </MenuItem>
 
      )}
   {/* </>
  ) 
  }  */}
</Menu>

      </Box>
    </Box>
    
  );
};

export default NotificationsMenu;
